import dayjs from 'dayjs';
import { IReviewSummaryReportFormValues } from './Containers/ReviewSummaryReportFormProvider/types';
import { IReviewSummaryReport } from '@Domains/ReviewSummaryReport';

export const mapReviewSummaryReportToFormValues = (
  data?: IReviewSummaryReport
): IReviewSummaryReportFormValues | undefined => {
  if (!data) return undefined;

  const { committeeApprovalDate, ...values } = data;

  return {
    ...values,
    committeeApprovalDate: committeeApprovalDate
      ? dayjs(committeeApprovalDate)
      : undefined,
  } as IReviewSummaryReportFormValues;
};
